import { render, staticRenderFns } from "./MonsterStats.vue?vue&type=template&id=f1074c56&scoped=true&"
import script from "./MonsterStats.vue?vue&type=script&lang=ts&"
export * from "./MonsterStats.vue?vue&type=script&lang=ts&"
import style0 from "./MonsterStats.vue?vue&type=style&index=0&id=f1074c56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1074c56",
  null
  
)

export default component.exports